module.exports = __webpack_public_path__ + "img/btn_homepage.14f7ead3.png";